import { jsx as e, jsxs as t } from "react/jsx-runtime";

import { SCHEDULE_SLOT_TYPES as l } from "../../utils.js";

import { useProviderSchedule as a } from "../../hooks/useProviderSchedule.js";

import o from "@ui-components-3/ui/lib/utils/classNames";

import { useMemo as r } from "react";

const s = {
    "Available Slots": [ "available" ],
    "Booked Slots": [ "new", "follow_up" ]
}, i = () => {
    const {slotsCounts: i, isSlotsFetching: n, isFetchingSchedules: c, variantClassNames: m} = a(), d = n || c, p = r((() => ({
        available: {
            label: m.availableSlotCountLabel,
            count: m.availableSlotCount
        },
        new: {
            label: "text-[#5250B1]",
            count: "bg-[#5250B1] text-white border-[#5250B1]"
        },
        follow_up: {
            label: "text-[#0C9070]",
            count: "bg-[#0C9070] text-white border-[#0C9070]"
        }
    })), [ m ]);
    return e("div", {
        className: "flex flex-wrap items-start gap-8",
        children: Object.entries(s).map((([a, r]) => t("div", {
            className: "flex shrink-0 flex-col gap-2",
            children: [ e("p", {
                className: "typography-body font-semibold leading-tight text-neutral-800",
                children: a
            }), e("div", {
                className: "flex flex-wrap items-center gap-4",
                children: r.map((a => {
                    const r = p[a];
                    return t("div", {
                        className: o("typography-body flex items-center gap-2 rounded-2xl border border-neutral-300 p-4 font-semibold", r?.label),
                        children: [ e("span", {
                            className: o("typography-small flex h-6 min-w-[42px] items-center justify-center rounded-full border-2 px-0.5 py-1.5 text-center font-semibold", r.count, !!d && "opacity-70"),
                            children: !d && (i?.[a] || 0)
                        }), l[a] ]
                    }, a);
                }))
            }) ]
        }, a)))
    });
};

export { i as default };
//# sourceMappingURL=index.js.map
